<div class="skills-completion-cont">
  <div class="completion-header">
    <div class="completion-header-row">
      <span class="completion-label">{{ 'global.complete_your_profile' | translate }}</span>
      <span class="completion-percentage">{{ completionPercentage }}%</span>
    </div>
    <div class="progress-bar-track">
      <div class="progress-bar-fill" [style.width.%]="completionPercentage"></div>
    </div>
  </div>

  <div class="skill-completion-row" *ngFor="let skill of skillsList">
    <div class="skill-completion-name">{{ skill.labelKey | translate }}</div>
    <div class="skill-completion-state">
      <span class="check-circle" [class.filled]="checkSkillState(skill.completionKey)">
        <svg
          *ngIf="checkSkillState(skill.completionKey)"
          width="12"
          height="12"
          viewBox="0 0 20 20"
          fill="currentColor"
        >
          <path
            fill-rule="evenodd"
            d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
            clip-rule="evenodd"
          />
        </svg>
      </span>
    </div>
  </div>
</div>
